export const TYPE_EMOJI = { huishouden: "🏠", gezin: "👨‍👩‍👧", studentenhuis: "🎓", vereniging: "🏢", instelling: "🏥", bedrijf: "💼" };

const resolve = (url) => (url && (url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`));

// Rendert de inhoud van een huishouden-icoon (afbeelding of emoji) binnen een bestaande wrapper.
export function OrgIconContent({ org, emoji, url, type }) {
  const imgUrl = url ?? org?.icon_url ?? org?.org_icon_url;
  const em = emoji ?? org?.icon_emoji ?? org?.org_icon_emoji;
  const tp = type ?? org?.type;
  if (imgUrl) return <img src={resolve(imgUrl)} alt="" className="w-full h-full object-cover" />;
  return <span>{em || TYPE_EMOJI[tp] || "🏠"}</span>;
}
